module.exports = __webpack_public_path__ + "static/medpar-3e037340c04ff1b4cffd56cc3ba48bf9.png";